const LevelType = Object.freeze({
  STREET: "STREET",
  BLOCK: "BLOCK",
  NEIGHBORHOOD: "NEIGHBORHOOD",
  POSTAL: "POSTAL",
  CITY: "CITY",
  COUNTY: "COUNTY",
  STATE: "STATE",
  COUNTRY: "COUNTRY"
});
export default LevelType;